// Function to get the image path from a given filename
export function getImagePathTech(imgPath) {
    try {
        return require(`@/assets/images/tech/${imgPath}`);
    } catch (error) {
        console.error('Error loading image:', error);
        return ''; // Return a placeholder or empty string if image loading fails
    }
}

// Function to get the image path from a given filename
export function getImagePathCompany(imgPath) {
    try {
        return require(`@/assets/images/company/${imgPath}`);
    } catch (error) {
        console.error('Error loading image:', error);
        return ''; // Return a placeholder or empty string if image loading fails
    }
}

export function getImagePathWJ(imgPath) {
    try {
        return require(`@/assets/images/wj/${imgPath}`);
    } catch (error) {
        console.error('Error loading image:', error);
        return ''; // Return a placeholder or empty string if image loading fails
    }
}

// Function to get project images - tries multiple paths
export function getImagePathProject(imgPath) {
    // Handle default-project.jpg specially since it's used as a fallback
    if (imgPath === 'default-project.jpg') {
        try {
            // Use json.jpg as a fallback since we know it exists
            return require('@/assets/images/json.jpg');
        } catch (error) {
            console.warn('Using base64 fallback for default-project.jpg');
            // Return a simple base64 placeholder image
            return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAA30lEQVR4nO3bMQ0AIAwAwfpXxAgYwAJCknuX9LPbjTQAAAAAAAAAAAAAAAAAtqrqeWbWaWf6zEsQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERARfCueV8HNOu3M6+39/+UQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREAEAAAAAAAAAAAAAAAAgwgO/4gNoOG5xxAAAAABJRU5ErkJggg==';
        }
    }

    // For all other images, try multiple paths
    try {
        // First try the main assets/images directory
        return require(`@/assets/images/${imgPath}`);
    } catch (error) {
        try {
            // Then try the wj folder for personal projects
            return require(`@/assets/images/wj/${imgPath}`);
        } catch (error2) {
            try {
                // Fallback to company folder
                return require(`@/assets/images/company/${imgPath}`);
            } catch (error3) {
                try {
                    // Fallback to tech folder
                    return require(`@/assets/images/tech/${imgPath}`);
                } catch (error4) {
                    console.error('Error loading project image:', imgPath, error4);
                    // Return a simple placeholder for any image that can't be found
                    return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAA30lEQVR4nO3bMQ0AIAwAwfpXxAgYwAJCknuX9LPbjTQAAAAAAAAAAAAAAAAAtqrqeWbWaWf6zEsQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERARfCueV8HNOu3M6+39/+UQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREBEQERAREAEAAAAAAAAAAAAAAAAgwgO/4gNoOG5xxAAAAABJRU5ErkJggg==';
                }
            }
        }
    }
}
